// @flow
import React from 'react'
import { FormattedMessage } from 'react-intl'
import RadioButton from '@components/common/radio-button'
import {
  PUBLICITY_DRAFT,
  PUBLICITY_PUBLIC,
  PUBLICITY_PRIVATE,
} from '@utils/constants'

interface Props {
  id: string
  publicity: string
  onUpdate: (publicity: string) => void
}

const Visibility = ({ id, publicity, onUpdate }: Props) => (
  <div className="publicity">
    <div className="hr" />
    <h4>
      <FormattedMessage
        id="soundnew.publicity.title"
        defaultMessage="Publicity Status"
      />
    </h4>
    <p className="help-block">
      <FormattedMessage
        id="soundnew.publicity.lead"
        defaultMessage="Make this sound public?"
      />
    </p>
    <div className="mb-1">
      <RadioButton
        className="d-block flex1 tx-14 mr-1"
        id={`${id}-public`}
        value={PUBLICITY_PUBLIC}
        name="publicity"
        checked={publicity === PUBLICITY_PUBLIC}
        onChange={() => onUpdate(PUBLICITY_PUBLIC)}
        bordered
      >
        <FormattedMessage
          id="soundnew.publicity.public"
          defaultMessage="Public"
        />
      </RadioButton>
    </div>
    <div className="d-flex mb-3">
      <RadioButton
        className="d-block flex1 tx-14"
        id={`${id}-private`}
        value={PUBLICITY_PRIVATE}
        name="publicity"
        checked={publicity === PUBLICITY_PRIVATE}
        onChange={() => onUpdate(PUBLICITY_PRIVATE)}
        bordered
      >
        <FormattedMessage
          id="soundnew.publicity.private"
          defaultMessage="Private"
        />
      </RadioButton>
      <RadioButton
        className="d-block flex1 tx-14"
        id={`${id}-draft`}
        value={PUBLICITY_DRAFT}
        name="publicity"
        checked={publicity === PUBLICITY_DRAFT}
        onChange={() => onUpdate(PUBLICITY_DRAFT)}
        bordered
      >
        <FormattedMessage
          id="soundnew.publicity.draft"
          defaultMessage="Draft"
        />
      </RadioButton>
    </div>
    <p className="help-block">
      {publicity === PUBLICITY_PUBLIC && (
        <FormattedMessage
          id="soundnew.publicity.publictxt"
          // eslint-disable-next-line max-len
          defaultMessage="Your sound will be visible to listeners, and may be eligible for curators to recommend to interested listeners based on your distribution setting."
        />
      )}
      {publicity === PUBLICITY_PRIVATE && (
        <FormattedMessage
          id="soundnew.publicity.privatetxt"
          // eslint-disable-next-line max-len
          defaultMessage="The sound will only be visible to those with the link. It won’t be listed on SOUND ON LIVE’s public pages (your profile, homepage)."
        />
      )}
      {publicity === PUBLICITY_DRAFT && (
        <FormattedMessage
          id="soundnew.publicity.drafttxt"
          // eslint-disable-next-line max-len
          defaultMessage="The sound will only be visible to you. You need to be signed in to SOUND ON LIVE to see this."
        />
      )}
    </p>
  </div>
)

// Visibility.defaultProps = {
// }

export default Visibility
